import Vue from 'vue'
import VueRouter from 'vue-router'
import staticRoutes from './static-routes'
import store from '@plugin/store'
import { $t, $te } from '@plugin/i18n'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Purchaser, Supplier, Setting } from './router'

NProgress.configure({}) // NProgress Configuration

const whiteList = ['Sign.Login', 'Page404', 'Sign.Register', 'Sign.Forgetpass'] // no redirect whitelist

Vue.use(VueRouter)

export const testRouter = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/purchaser',
    name: 'Root.Purchaser',
    component: { render: (h: any) => h('router-view') },
    children: [{ path: '*', component: { render: (h: any) => h('div') }}]
  }, {
    path: '/supplier',
    name: 'Root.Supplier',
    component: { render: (h: any) => h('router-view') },
    children: [{ path: '*', component: { render: (h: any) => h('div') }}]
  }, {
    path: '/setting',
    name: 'Root.Setting',
    component: { render: (h: any) => h('router-view') },
    children: [{ path: '*', component: { render: (h: any) => h('div') }}]
  }]
})

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: staticRoutes
})

router.beforeEach(async(to: any, from, next) => {
  NProgress.start()

  const title = $te(to.meta.title) ? $t(to.meta.title) : to.meta.title
  document.title = title ? `${title}-SRM` : 'SRM'
  // 有token值
  if (store.getters.token) {
    // 从登录页面直接跳转到首页，不需要登陆
    if (to.name === 'Sign.Login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      next()
    }
  // 没有token值
  } else {
    // 白名单中路由不需要token
    if (to.name && whiteList.indexOf(to.name) !== -1) {
      next()
    } else {
      next(`/sign/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})

const purchaser = Purchaser.getRouter
const supplier = Supplier.getRouter
const manage = Setting.getRouter
const routes = [purchaser, manage, supplier]
export { routes }

export function resetRouter(routes = []) {
  const newRouter = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
      return { x: 0, y: 0 }
    },
    routes: [...staticRoutes, ...routes]
  });
  // eslint-disable-next-line
  (router as any).matcher = (newRouter as any).matcher
}

export default router
